import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { apiFetch } from "../../modules/utility";

const runDriverReport = ({ params = {}, callback = _.noop }) => {
  return (dispatch) => {
    apiFetch({
      method: `reporting.driver.run`,
      params,
      dispatch,
      callback,
    });
  };
};

const runDriverDetailReport = ({ params = {}, callback = _.noop }) => {
  return (dispatch) => {
    apiFetch({
      method: `reporting.driver.detail.run`,
      params,
      dispatch,
      callback,
    });
  };
};

const mapStateToProps = (state) => {
  const newState = {};
  newState.userMap = state.maps.user;
  return newState;
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      runDriverReport,
      runDriverDetailReport,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps);
